import Component from 'umg-ember-backend/components/record-explorer';

export default class ListCompontensTaxonComponent extends Component {
  // Defaults
  availableFilters = [];
  defaultColumns = ['id', 'title', 'slug', 'taxonomy'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'title',
      isMainColumn: true,
    },
    {
      property: 'slug',
    },
    {
      property: 'taxonomy',
      type: 'relation',
    },
  ];
}
